export const MAX_TOC_DEPTH = 2;
